import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../../services/common.service';
import { ManageService } from '../../../../../services/manage.service';
import { AnnuityItems } from '../../../../../models/annuity-details-view.model';
import { AnnuityItemsViewModel } from '../../../../../models/annuity-view.model';
import { IBreadcrumb } from '../../../../../breadcrumb/breadcrumb.interface';
import { ApiResponse } from '../../../../../models/api-response.model';
import { BreadcrumbService } from '../../../../../services/breadcrumb.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-add-sc-subscriptions',
  templateUrl: './add-sc-subscriptions.component.html',
  styleUrls: ['./add-sc-subscriptions.component.css']
})
export class AddStorageCraftSubscriptionsComponent implements OnInit, AfterViewInit {

  searchOrder = '';

  annuityItems: AnnuityItems;

  newItemsList: AnnuityItemsViewModel[] = [];

  loadContent: boolean;

  // params
  programType = 'STMSP';
  programName = '';
  annuityId = '';
  orderNo = '';
  orderSuffix = '';
  vendorAgreementNo = '';
  breadcrumbItems: IBreadcrumb[] = [];

  url: string;

  constructor(
    private manageService: ManageService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private router: Router
  ) { }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.programType === 'CITRIXCSP') {
        const item = {
          label: 'Add-Citrix-Csp-Subscriptions',
          url: ''
        } as IBreadcrumb;
        this.breadcrumbItems.push(item);
      } else {
        const item = {
          label: 'Add-Spla-Subscriptions',
          url: ''
        } as IBreadcrumb;
        this.breadcrumbItems.push(item);
      }
      this.breadcrumbService.setBreadCrumb(this.breadcrumbItems);
    });
  }

  ngOnInit() {
    this.breadcrumbItems = [];
    this.searchOrder = '';
    this.activatedRoute.parent.paramMap.subscribe(param => {
      $('#levelOne').animate({ scrollLeft: $('#managespladetails').width() + 505 }, 400);
      this.loadContent = false;
      this.annuityId = param.get('annuityId');
      this.orderNo = param.get('orderNo');
      this.vendorAgreementNo = param.get('vendorAgreementNo');
      if (param.get('orderSuffix') && param.get('orderSuffix') !== 'OrderSuffix') { this.orderSuffix = param.get('orderSuffix'); }
      this.manageService.getItemList(this.annuityId, this.programType, this.orderNo, this.orderSuffix).subscribe((values: AnnuityItemsViewModel[]) => {
        this.newItemsList = values;
        this.loadContent = true;
      }, (error: any) => {
        console.error(error);
      });
    });
  }

  addAnnuityItem(item: AnnuityItemsViewModel, qty: string): void {
    this.loadContent = false;
    this.manageService.addAnnuityItem(item.stockCode, item.orderNo, item.orderSuffix, this.annuityId, item.lineSequence, qty).subscribe((value: ApiResponse) => {
      // refresh anuity items array after update
      if (value && value.status) {
        this.commonService.implementToast('New Item added', 'Success');
        this.loadContent = true;
        this.manageService.monitorPendingSpla(true);
        setTimeout(() => {
          this.close();
        }, 1000);
      } else {
        this.loadContent = true;
        this.commonService.implementToast('Unable to add new item', 'Error');
      }
    }, (error: any) => {
      this.loadContent = true;
      this.commonService.implementToast('Unable to add new item', 'Error');
      console.error(error);
    });
  }

  close() {
    $("#levelOne").animate({ scrollLeft: 250 }, 400);
    this.router.navigateByUrl(`/manageSubscriptions/${this.programType}/STMSPDetails/${this.annuityId}/${this.orderNo}/${this.vendorAgreementNo}/${this.orderSuffix ? this.orderSuffix : 'OrderSuffix'}`);
  }
}
